import { graphql } from "relay-runtime"

export const chPatientByPatientIdQuery = graphql`
  query chPatientByPatientIdQuery($patientId: UUID!) {
    patientByPatientId: ch_patientByPatientId(patientId: $patientId) {
      id
    }
  }
`
